import  React, { useState }  from "react";
import { Col, Row, Button, Alert, Badge, UncontrolledTooltip } from "reactstrap";
import ToolkitProvider, {
  CSVExport
} from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import TableHelper from "../components/tableHelper";
import ModalConfirm from "../components/modalConfirm";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

const MasteringSongsTable = ({
  tableData,
  error,
  loading,
}) => {
    const { ExportCSVButton } = CSVExport;
    const { t } = useTranslation();

    const presetDict = {
      'm': t("mastering.viewSongs.option.preset.acoustic"),
      'i': t("mastering.viewSongs.option.preset.allGenres"),
      'n': t("mastering.viewSongs.option.preset.classical"),
      'b': t("mastering.viewSongs.option.preset.clubHouseTechno"),
      'h': t("mastering.viewSongs.option.preset.edmMusic"),
      'f': t("mastering.viewSongs.option.preset.electronic"),
      'g': t("mastering.viewSongs.option.preset.electronicRaw"),
      'c': t("mastering.viewSongs.option.preset.hipHop"),
      'd': t("mastering.viewSongs.option.preset.hipHopBass"),
      'a': t("mastering.viewSongs.option.preset.popMusic"),
      'k': t("mastering.viewSongs.option.preset.popRnB"),
      'j': t("mastering.viewSongs.option.preset.rockMetal"),
      'e': t("mastering.viewSongs.option.preset.trap"),
      'l': t("mastering.viewSongs.option.preset.vocalFocused")
    };

    //ajax handlers
    const [success, setSuccess] = useState(false);
    const [errorPut, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState(t("mastering.viewSongs.message.error"));
    const [redirect, setRedirect] = useState(false);
    const [openModal, setToggleModal] = useState(false);
    const [dataModal, setDataModal] = useState(null);
    const [masteringType, setMasteringType] = useState("");
    const [fetching, setFetching] = useState(false);

    const download = (url, name) => {
      if (!url) {
        throw new Error("Resource URL not provided! You need to provide one");
      }
      setFetching(true);
      fetch(url)
      .then(response => response.blob())
      .then(blob => {
        setFetching(false);
        const blobURL = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobURL;
        a.style = "display: none";

        if (name && name.length) a.download = name;
        document.body.appendChild(a);
        a.click();
      })
      .catch(() => setError(true));
  };

  const generateMastering = (song_id, mastering_type) => {
    setMasteringType(mastering_type);
    setError(false);
    setErrorMsg("");

    setDataModal({
      song_id: song_id,
      mastering_type: mastering_type
    });

    setToggleModal(true);
  }
  
  const previewDownloadFormatter = (cell, row, rowIndex) =>
  row.preview_count>0 ?
  (
    cell? (
      <Button className="btn" color="primary" onClick={()=> download(cell, cell.split(/(\\|\/)/g).pop())} disabled={fetching}>
        <i class="fas fa-download"></i>
      </Button>
    ):
    (
      <>
        <i className="text-warning mdi mdi-36px mdi-clock-start" id={`prvw-gen-id-${rowIndex}`}></i>
        {!cell &&
          <UncontrolledTooltip placement="top" trigger="hover" target={`prvw-gen-id-${rowIndex}`}>{t("mastering.viewSongs.message.previewDownloadTooltip")}</UncontrolledTooltip>
        }
      </>
    )
  ) : <b>-</b>;

  const masterCsvFormatter = (cell, row) =>
  cell ?
  ( 
    cell
  ) : (t("mastering.viewSongs.label.notAvailable"));

  const masteringDownloadFormatter = (cell, row, rowIndex) =>
  row.mastering_expedited ?
  (
    cell? (
      <Button className="btn" color="primary" onClick={()=> download(cell, cell.split(/(\\|\/)/g).pop())} disabled={fetching}>
        <i class="fas fa-download"></i>
      </Button>
    ):
    (
      <>
        <i className="text-warning mdi mdi-36px mdi-clock-start" id={`mstr-gen-id-${rowIndex}`}></i>
        {!cell &&
          <UncontrolledTooltip placement="top" trigger="hover" target={`mstr-gen-id-${rowIndex}`}>{t("mastering.viewSongs.message.masteringDownloadTooltip")}</UncontrolledTooltip>
        }
      </>
    )
  ) : <b>-</b>;

  const masterActionFormatter = (cell, row, rowIndex) => {
    const btnId = `mastering-btn-${rowIndex}`;
    return (
      <>
      <span id={btnId}>
        <Button className="btn btn-outline-primary" style={{pointerEvents: row.mastering_expedited? 'none': 'auto'}} color="primary" disabled={row.mastering_expedited ? true : false} onClick={() => generateMastering(row.id, "master")}>{t("mastering.viewSongs.table.button.generate")}</Button>
      </span>
      {row.mastering_expedited &&
        <UncontrolledTooltip placement="top" trigger="hover" target={btnId}>{t("mastering.viewSongs.message.alreadyMasteredTooltip")}</UncontrolledTooltip>
      }
      </>
    );
  };

  const previewActionFormatter = (cell, row) => {
    return (
      <>
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        <Button className="btn btn-outline-primary" color="primary" disabled={(row.preview_count>=5 || row.mastering_expedited) ? true : false} onClick={() => generateMastering(row.id, "preview")}>{t("mastering.viewSongs.table.button.generate")}</Button>
        <Badge color="danger" className="ml-1" style={{fontSize: '13px', fontWeight: 'bold', marginTop: '5px'}}>{t("mastering.viewSongs.table.label.previewAttemptsLeft", {count: 5 - row.preview_count})}</Badge>
      </div>
      </>
    );
  };
 
  const masteringExpeditedFormatter = (cell, row) =>
  cell ?
  (
    <span className="p-4" >
      <i className="fas fa-2x fa-check-circle text-success"></i>
    </span>
  ) :     
  (
    <span className="p-4">
      <i className="fas fa-2x fa-times-circle text-danger"></i>
    </span>
  );

  const editActionFormatter = (cell, row) =>
    row.mastering_expedited ?
    (
      <Button className="btn btn-outline-primary" disabled={true} color="primary">
        {t("mastering.viewSongs.table.button.edit")}
      </Button>
    ) : (
      <Link className="btn btn-outline-primary" disabled={!row.mastering_expedited} to={`/mastering/${row.id}/edit-parameters/`}>{t("mastering.viewSongs.table.button.edit")}</Link>
    );

  const presetFormatter = (cell, row) =>
  cell ?
  ( 
    presetDict[cell]
  ) : ('-');  
  
  const intensityLoudnessFormatter = (cell, row) =>
    `${row.intensity} % / ${row.target_level} dB`;

  const columns = [
    {
      dataField: "tag",
      text: t("mastering.viewSongs.table.column.name"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "50px" };
      }
    },
    {
      dataField: "preset",
      text: t("mastering.viewSongs.table.column.preset"),
      sort: true,
      formatter: presetFormatter,
      csvFormatter: presetFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "50px" };
      }
    },
    {
      dataField: "intensity_and_loudness",
      text: t("mastering.viewSongs.table.column.intensityAndLoudness"),
      formatter: intensityLoudnessFormatter,
      csvFormatter: intensityLoudnessFormatter,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "50px" };
      }
    },
    {
      dataField: "generate_preview",
      text: t("mastering.viewSongs.table.column.preview"),
      csvExport: false,
      formatter: previewActionFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "55px" };
      }
    },
    {
      dataField: "generate_mastering",
      text: t("mastering.viewSongs.table.column.master"),
      csvExport: false,
      formatter: masterActionFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "50px" };
      }
    },
    {
      dataField: "preview_result",
      text: t("mastering.viewSongs.table.column.previewResult"),
      formatter: previewDownloadFormatter,
      csvFormatter: masterCsvFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "30px" };
      }
    },
    {
      dataField: "result_file",
      text: t("mastering.viewSongs.table.column.masteringResult"),
      formatter: masteringDownloadFormatter,
      csvFormatter: masterCsvFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "30px" };
      }
    },
    {
      dataField: "mastering_expedited",
      text: t("mastering.viewSongs.table.column.mastered"),
      sort: true,
      formatter: masteringExpeditedFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "40px" };
      }
    },
    {
      dataField: "edit",
      text: t("mastering.viewSongs.table.column.action"),
      formatter: editActionFormatter,
      csvExport: false,
      headerStyle: (colum, colIndex) => {
        return { width: "20px" };
      }
    },
  ];

  return (
    <>
      {
        <div>
            {(success && masteringType==="master") && (
              <Alert color="success">
                <Trans i18nKey="mastering.viewSongs.message.successMaster">
                  Song sent for Mastering generation!<br/>Note: Please check in few minutes as it takes 7-15 minutes for generating mastering.
                </Trans>
              </Alert>
            )}
            {(success && masteringType==="preview") && (
              <Alert color="success">
                <Trans i18nKey="mastering.viewSongs.message.successPreview">
                  Song sent for Mastering Preview generation!<br/>Note: Please check in few minutes as it takes 5-6 minutes for generating mastering preview.
                </Trans>
              </Alert>
            )}
            {redirect ? window.location.reload() : null}
            {errorPut && (
              <Alert color="danger">
                {errorMsg}
              </Alert>
            )}
        </div>
      }
      {loading ? (
        <TableHelper loading />
      ) : error ? (
        <TableHelper error />
      ) : (
        <ToolkitProvider
          keyField="id"
          data={tableData}
          columns={columns}
          exportCSV={ {
            fileName: 'audio-mastering-songs.csv',
          } }
        >
          {props => (
            <div>
              <Row>
                <Col>
                  <div className="m-5 m-5">
                  </div>
                </Col>
                <Col>
                  <div className="flexEndContainer">

                    <ExportCSVButton
                      className="btn btn-outline-info"
                      {...props.csvProps}
                    >
                      {t("mastering.viewSongs.table.button.exportCsv")}
                    </ExportCSVButton>
                  </div>
                </Col>
              </Row>

              <BootstrapTable
               {...props.baseProps}
                bordered={ false }
              />
            </div>
          )}
        </ToolkitProvider>
      )}
      {
        <ModalConfirm
          openModal={openModal}
          setToggleModal={setToggleModal}
          dataModal={dataModal}
          title={masteringType==='master'? t("mastering.viewSongs.modal.generateMastering.header") : t("mastering.viewSongs.modal.generateMasteringPreview.header")}
          setSuccess={setSuccess}
          setRedirect={setRedirect}
          setError={setError}
          body={masteringType==='master'? t("mastering.viewSongs.modal.generateMastering.body") : t("mastering.viewSongs.modal.generateMasteringPreview.body")}
          apiURL={`dolby_master`}
          successMsg={masteringType==='master'? t("mastering.viewSongs.modal.generateMastering.message.success") : t("mastering.viewSongs.modal.generateMasteringPreview.message.success")}
        />
      }
    </>
  );
};

export default MasteringSongsTable;